function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M78.52 32.76C81 49.42 76.15 62.3 67.24 70.39l-12.62-9.83a20.74 20.74 0 008.19-12.37H40.92V32.76z",
  fill: "#4286f5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M67.68 10.33l-11.5 11.36a22.05 22.05 0 00-15.33-6 24 24 0 00-22.7 16.58L5.08 22.09a40 40 0 0162.6-11.76z",
  fill: "#ea4235"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M54.62 60.56l12.62 9.83C60.36 76.64 51.05 80 40.85 80A40 40 0 015.08 57.91l13.07-10.14a24 24 0 0022.7 16.57c5.71 0 10.27-1.34 13.77-3.78z",
  fill: "#34a853"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5.08 22.09l13.07 10.15a24.74 24.74 0 000 15.53L5.08 57.91a40 40 0 010-35.82z",
  fill: "#fbbc05"
});

var SvgConnectGoogle = function SvgConnectGoogle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConnectGoogle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/connect-google.69718f2e.svg";
export { ForwardRef as ReactComponent };